/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Layout } from 'antd'
import 'antd/dist/antd.less'
import React from 'react'
import { MenuItems, menus } from '../../config/menu'
import { AuthContext } from '../../contexts/Auth'
import { SidebarCollapseContext } from '../../contexts/SidebarCollapse'
import '../../static/css/index.less'
import HeaderMenu from '../HeaderMenu/HeaderMenu'
import SideMenu from '../SideMenu/SideMenu'

const { Content, Footer } = Layout

interface AppProps {
  children: React.ReactNode
}

interface AppState {
  collapsed: boolean
  sidebarHidden: boolean
  user: any
}

type CRUD = 'c' | 'r' | 'u' | 'd'

interface listMenu {
  menu_id: number
  group: number | null
  permission: Record<CRUD, 0 | 1>
  menu_name: string
  menu_path: string | null
  menu_label: string
}

interface MenuLayout extends listMenu {
  key: string
  subMenu?: listMenu[]
}

class Page extends React.Component<AppProps, AppState> {
  static contextType = AuthContext
  state = {
    collapsed: false,
    sidebarHidden: localStorage.getItem('nav_sidebar_hidden') === 'true',
    user: {
      userId: null,
      userName: '',
      userToken: null,
    },
  }
  user = {
    userId: null,
    userName: '',
    userToken: null,
  }

  onCollapse = (collapsed: boolean): void => {
    this.setState({ collapsed })
  }

  genMenus(menus: MenuItems[]): MenuItems[] {
    const listMenu: listMenu[] = this.context?.permission?.listMenu
    // 1 - Change API permission to add menu route
    const permissionStorage = localStorage.getItem('permission')
    const allMenus = permissionStorage ? JSON.parse(permissionStorage).listMenu || [] : []
    // const listMenuWithAllowedPermissions = listMenu?.filter((listMenu) => {
    //   const crudPermissions = Object.values(listMenu.permission)
    //   return crudPermissions.some((permission) => permission === 1)
    // })
    const listMenuWithAllowedPermissions = [...allMenus]

    // Affiliate pages. Same fallback as Ski/Queue: visible before a menu row exists in permissions.
    const affiliateParent = {
      menu_id: 999960,
      group: null,
      permission: { c: 1, r: 1, u: 1, d: 1 },
      menu_name: 'affiliate',
      menu_path: null,
      menu_label: 'Affiliate',
    }
    if (
      !listMenuWithAllowedPermissions.some(
        (item: listMenu) => item.menu_id === affiliateParent.menu_id,
      )
    ) {
      listMenuWithAllowedPermissions.push(affiliateParent)
    }
    const affiliatePages = [
      {
        menu_id: 999961,
        menu_name: 'affiliate_settings',
        menu_path: '/affiliate/settings',
        menu_label: 'Settings',
      },
      {
        menu_id: 999962,
        menu_name: 'affiliate_list',
        menu_path: '/affiliate/affiliates',
        menu_label: 'Affiliates',
      },
      {
        menu_id: 999963,
        menu_name: 'affiliate_commissions',
        menu_path: '/affiliate/commissions',
        menu_label: 'Commissions',
      },
    ]
    for (const page of affiliatePages) {
      if (
        !listMenuWithAllowedPermissions.some((item: listMenu) => item.menu_path === page.menu_path)
      ) {
        listMenuWithAllowedPermissions.push({
          ...page,
          group: affiliateParent.menu_id,
          permission: { c: 1, r: 1, u: 1, d: 1 },
        })
      }
    }

    // Temporary fallback: ensure Ski Storage menu is visible even before APA menu setup.
    let skiParentMenu = listMenuWithAllowedPermissions.find(
      (item: listMenu) =>
        item.menu_path === null &&
        /ski/i.test(String(item.menu_label || '') + String(item.menu_name || '')),
    )
    if (!skiParentMenu) {
      skiParentMenu = {
        menu_id: 999990,
        group: null,
        permission: { c: 1, r: 1, u: 1, d: 1 },
        menu_name: 'ski',
        menu_path: null,
        menu_label: 'Ski',
      }
      listMenuWithAllowedPermissions.push(skiParentMenu)
    }

    const skiStorageMenuIndex = listMenuWithAllowedPermissions.findIndex(
      (item: listMenu) => item.menu_path === '/ski-storage/bookings',
    )
    if (skiStorageMenuIndex >= 0) {
      listMenuWithAllowedPermissions[skiStorageMenuIndex] = {
        ...listMenuWithAllowedPermissions[skiStorageMenuIndex],
        group: skiParentMenu.menu_id,
        menu_label:
          listMenuWithAllowedPermissions[skiStorageMenuIndex].menu_label || 'Ski Storage Booking',
      }
    } else {
      listMenuWithAllowedPermissions.push({
        menu_id: 999991,
        group: skiParentMenu.menu_id,
        permission: { c: 1, r: 1, u: 1, d: 1 },
        menu_name: 'ski_storage_booking',
        menu_path: '/ski-storage/bookings',
        menu_label: 'Ski Storage Booking',
      })
    }

    // Temporary fallback: ensure Queue menu is visible even before APA menu setup.
    let queueParentMenu = listMenuWithAllowedPermissions.find(
      (item: listMenu) =>
        item.menu_path === null &&
        /queue/i.test(String(item.menu_label || '') + String(item.menu_name || '')),
    )
    if (!queueParentMenu) {
      queueParentMenu = {
        menu_id: 999970,
        group: null,
        permission: { c: 1, r: 1, u: 1, d: 1 },
        menu_name: 'queue',
        menu_path: null,
        menu_label: 'Queue',
      }
      listMenuWithAllowedPermissions.push(queueParentMenu)
    }

    const queueBookingMenuIndex = listMenuWithAllowedPermissions.findIndex(
      (item: listMenu) => item.menu_path === '/queue/bookings',
    )
    if (queueBookingMenuIndex >= 0) {
      listMenuWithAllowedPermissions[queueBookingMenuIndex] = {
        ...listMenuWithAllowedPermissions[queueBookingMenuIndex],
        group: queueParentMenu.menu_id,
        menu_label:
          listMenuWithAllowedPermissions[queueBookingMenuIndex].menu_label || 'Queue Booking',
      }
    } else {
      listMenuWithAllowedPermissions.push({
        menu_id: 999971,
        group: queueParentMenu.menu_id,
        permission: { c: 1, r: 1, u: 1, d: 1 },
        menu_name: 'queue_booking',
        menu_path: '/queue/bookings',
        menu_label: 'Queue Booking',
      })
    }

    // Temporary fallback: ensure Station Rent Payment menu is visible before APA menu setup.
    let stationRentParentMenu = listMenuWithAllowedPermissions.find(
      (item: listMenu) =>
        item.menu_path === null &&
        /station.?rent/i.test(String(item.menu_label || '') + String(item.menu_name || '')),
    )
    if (!stationRentParentMenu) {
      stationRentParentMenu = {
        menu_id: 999972,
        group: null,
        permission: { c: 1, r: 1, u: 1, d: 1 },
        menu_name: 'station_rent',
        menu_path: null,
        menu_label: 'Station Rent',
      }
      listMenuWithAllowedPermissions.push(stationRentParentMenu)
    }

    const stationRentPaymentMenuIndex = listMenuWithAllowedPermissions.findIndex(
      (item: listMenu) => item.menu_path === '/station-rent-payment',
    )
    if (stationRentPaymentMenuIndex >= 0) {
      listMenuWithAllowedPermissions[stationRentPaymentMenuIndex] = {
        ...listMenuWithAllowedPermissions[stationRentPaymentMenuIndex],
        group: stationRentParentMenu.menu_id,
        menu_label:
          listMenuWithAllowedPermissions[stationRentPaymentMenuIndex].menu_label ||
          'Station Rent Payment',
      }
    } else {
      listMenuWithAllowedPermissions.push({
        menu_id: 999973,
        group: stationRentParentMenu.menu_id,
        permission: { c: 1, r: 1, u: 1, d: 1 },
        menu_name: 'station_rent_payment',
        menu_path: '/station-rent-payment',
        menu_label: 'Station Rent Payment',
      })
    }

    // Temporary fallback: ensure Feedback Loop analytics is visible before APA menu setup.
    let analyticsParentMenu = listMenuWithAllowedPermissions.find(
      (item: listMenu) =>
        item.menu_path === null &&
        /analytics/i.test(String(item.menu_label || '') + String(item.menu_name || '')),
    )
    if (!analyticsParentMenu) {
      analyticsParentMenu = {
        menu_id: 999980,
        group: null,
        permission: { c: 1, r: 1, u: 1, d: 1 },
        menu_name: 'analytics',
        menu_path: null,
        menu_label: 'Analytics',
      }
      listMenuWithAllowedPermissions.push(analyticsParentMenu)
    }

    const feedbackLoopMenuIndex = listMenuWithAllowedPermissions.findIndex(
      (item: listMenu) => item.menu_path === '/analytics/submission-feedback-loop',
    )
    if (feedbackLoopMenuIndex >= 0) {
      listMenuWithAllowedPermissions[feedbackLoopMenuIndex] = {
        ...listMenuWithAllowedPermissions[feedbackLoopMenuIndex],
        group: analyticsParentMenu.menu_id,
        menu_label:
          listMenuWithAllowedPermissions[feedbackLoopMenuIndex].menu_label ||
          'Submission Feedback Loop',
      }
    } else {
      listMenuWithAllowedPermissions.push({
        menu_id: 999981,
        group: analyticsParentMenu.menu_id,
        permission: { c: 1, r: 1, u: 1, d: 1 },
        menu_name: 'submission_feedback_loop',
        menu_path: '/analytics/submission-feedback-loop',
        menu_label: 'Submission Feedback Loop',
      })
    }

    // Revenue Intelligence is controlled entirely by the /permissions page: only show it when
    // the permission API returns an active, read-granted entry for this user. No full-access
    // fallback like the other menus above — toggling ACTIVATE/DEACTIVATE (or can_read) on the
    // Permission row for this menu is what shows/hides it, so it's the only place needed.
    const revenueIntelligenceMenuIndex = listMenuWithAllowedPermissions.findIndex(
      (item: listMenu) => item.menu_path === '/analytics/revenue-intelligence',
    )
    if (revenueIntelligenceMenuIndex >= 0) {
      const revenueIntelligenceMenu = listMenuWithAllowedPermissions[revenueIntelligenceMenuIndex]
      if (revenueIntelligenceMenu.permission?.r === 1) {
        listMenuWithAllowedPermissions[revenueIntelligenceMenuIndex] = {
          ...revenueIntelligenceMenu,
          group: analyticsParentMenu.menu_id,
          menu_label: revenueIntelligenceMenu.menu_label || 'Revenue Intelligence',
        }
      } else {
        listMenuWithAllowedPermissions.splice(revenueIntelligenceMenuIndex, 1)
      }
    }

    // "Add widget REV" (where cards/filters are configured) has no menu row of its
    // own: it follows the Revenue Intelligence permission and shows up only for users who can
    // create/update there, under the same Analytics group.
    const revenueIntelligenceAddPath = '/analytics/revenue-intelligence-add'
    const revenueIntelligenceRow = listMenuWithAllowedPermissions.find(
      (item: listMenu) => item.menu_path === '/analytics/revenue-intelligence',
    )
    const canAddRevenueIntelligence =
      revenueIntelligenceRow?.permission?.c === 1 || revenueIntelligenceRow?.permission?.u === 1
    const existingAddIndex = listMenuWithAllowedPermissions.findIndex(
      (item: listMenu) => item.menu_path === revenueIntelligenceAddPath,
    )
    if (existingAddIndex >= 0) listMenuWithAllowedPermissions.splice(existingAddIndex, 1)
    if (canAddRevenueIntelligence) {
      listMenuWithAllowedPermissions.push({
        menu_id: 999982,
        group: analyticsParentMenu.menu_id,
        permission: revenueIntelligenceRow.permission,
        menu_name: 'revenue_intelligence_add',
        menu_path: revenueIntelligenceAddPath,
        menu_label: 'Add widget REV',
      })
    }

    const listMenuNoGroup = listMenuWithAllowedPermissions?.filter(
      (listMenu) => listMenu.group === null,
    )
    const listMenuHaveGroup = listMenuWithAllowedPermissions?.filter(
      (listMenu) => listMenu.group !== null,
    )

    // modify the API later
    const groupedMenus = listMenuHaveGroup.reduce((acc: Record<string, listMenu[]>, listItem) => {
      if (!acc[listItem.group]) acc[listItem.group] = [listItem]
      else acc[listItem.group].push(listItem)
      return acc
    }, {})

    const menuLayout: MenuLayout[] = listMenuNoGroup?.map((listMenu) => {
      const findSubMenu = Object.entries(groupedMenus).find(
        ([group, _]) => group === String(listMenu.menu_id),
      )
      const haveSubMenu = findSubMenu !== undefined

      if (haveSubMenu) {
        return {
          ...listMenu,
          key: listMenu.menu_name,
          subMenu: findSubMenu![1],
        }
      } else {
        return { ...listMenu, key: listMenu.menu_name }
      }
    })

    // Previous version
    const menuAllow: MenuItems[] = []
    // for (const group_menu of menus) {
    //   const { key, subMenu } = group_menu
    //   if (!subMenu) {
    //     const check = listMenuNoGroup?.findIndex((v) => v.menu_id === key)
    //     if (check >= 0) menuAllow.push(group_menu)
    //   } else {
    //     const check = listMenuHaveGroup?.findIndex((v) => v.group === key)
    //     if (check >= 0) {
    //       const list = listMenuHaveGroup?.filter((v) => v.group === key)
    //       const subMenuAllow: MenuItems[] = []
    //       for (const subSubmenu of subMenu) {
    //         const check = list?.findIndex((v) => v.menu_id === subSubmenu.key)
    //         if (check >= 0) subMenuAllow.push(subSubmenu)
    //       }
    //       if (subMenuAllow.length > 0) {
    //         menuAllow.push({
    //           key: group_menu.key,
    //           title: group_menu.title,
    //           link: group_menu.link,
    //           subMenu: subMenuAllow,
    //         })
    //       }
    //     }
    //   }
    // }

    for (const menu of menuLayout) {
      const subMenuObject = !menu.subMenu
        ? {}
        : {
            subMenu: menu?.subMenu!.map((subMenu) => ({
              key: subMenu.menu_name,
              title: subMenu.menu_label,
              link: subMenu.menu_path || undefined,
            })) as unknown as MenuItems[],
          }
      menuAllow.push({
        key: menu.menu_name,
        title: menu.menu_label,
        link: menu.menu_path || undefined,
        ...subMenuObject,
      })
    }

    return menuAllow
  }

  render(): JSX.Element {
    const { sidebarHidden } = this.state
    return (
      <SidebarCollapseContext.Provider
        value={{
          sidebarHidden,
          setSidebarHidden: (hidden: boolean) => {
            localStorage.setItem('nav_sidebar_hidden', String(hidden))
            this.setState({ sidebarHidden: hidden })
          },
        }}
      >
        <Layout style={{ height: '100vh' }}>
          <div style={{ display: sidebarHidden ? 'none' : undefined }}>
            <SideMenu collapsed={false} menus={this.genMenus(menus)} />
          </div>
          <Layout className="site-layout" style={{ height: '100vh' }}>
            <div style={{ display: sidebarHidden ? 'none' : undefined }}>
              <HeaderMenu
                headerText={this.genMenus(menus)}
                username={this.context.user.username}
                location={this.props.children}
              />
            </div>
            <Content style={{ margin: '16px', overflow: 'auto' }}>
              <div
                className="site-layout-background"
                style={{ padding: 12, minHeight: 360, height: '100%', overflow: 'auto' }}
              >
                {this.props.children}
              </div>
            </Content>
            {/* <Footer style={{ textAlign: 'center' }}>Develop by HAUP</Footer> */}
          </Layout>
        </Layout>
      </SidebarCollapseContext.Provider>
    )
  }
}

export default Page
